import * as React from "react";

import { IconCancel } from "../icons/IconCancel";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";

export const IconButtonClearSearch: React.FC<MprcIconButtonProps> = ({ title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonClearSearch.title;
    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconCancel fixedWidth />
        </MprcIconButton>
    );
};
